export const pathsToAvoidByAssistantIcon = [
  '/settings/assistant',
  '/auth/login',
  'auth/register',
];
